<div class="page-wrapper p-3">
  <div class="container p0">
    <div class="row">
      <div class="col-12">
        <div class="form-group col">
          <div class="mb-2 text-center">
            <h1>Do you want to delete previous selected Colleges?</h1>
          </div>
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-12">
          <!-- <div class="col-md-2 mb-4 mt-4">Mail me</div> -->
          <div class="form-group row pt-3 text-right">
            <div class="col btn-section text-center mt-2">
              <a class="page-close-btn mx-1" (click)="select('yes')">Yes, Remove them</a>

              <button class="page-btn mx-1" type="submit" (click)="select('no')" type="submit">
                Don't Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    
  </div>
</div>
